<template>
	<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
		<a-form :form="form" @submit="handleSubmit">
			<div class="row">
				<div class="col-6">
					<a-form-item label="Empresa Origen">
						<a-select
							v-decorator="[
								'company_origin',
								{
									rules: [
										{
											required: true,
											message: 'Campo requerido.',
										},
									],
								},
							]"
						>
							<a-select-option value="s2r"> S2R </a-select-option>
							<a-select-option value="fsjt"> Fabián San Juan Tolentino </a-select-option>
							<a-select-option value="jlpg"> José Luis Pozos Gutierrez </a-select-option>
						</a-select>
					</a-form-item>
				</div>
				<div class="col-6">
					<a-form-item label="Empresa Destino">
						<a-select
							v-decorator="[
								'company_destination',
								{
									rules: [
										{
											required: true,
											message: 'Campo requerido.',
										},
									],
								},
							]"
						>
							<a-select-option value="s2r"> S2R </a-select-option>
							<a-select-option value="fsjt"> Fabián San Juan Tolentino </a-select-option>
							<a-select-option value="jlpg"> José Luis Pozos Gutierrez </a-select-option>
						</a-select>
					</a-form-item>
				</div>
				<div class="col-4">
					<a-form-item label="Forma de pago origen">
						<a-select
							v-decorator="[
								'payment_origin',
								{
									rules: [
										{
											required: true,
											message: 'Campo requerido.',
										},
									],
								},
							]"
						>
							<a-select-option value="cash"> Efectivo </a-select-option>
							<a-select-option value="bank_transfer"> Dinero en Banco </a-select-option>
						</a-select>
					</a-form-item>
				</div>
				<div class="col-4">
					<a-form-item label="Forma de pago destino">
						<a-select
							v-decorator="[
								'payment_destination',
								{
									rules: [
										{
											required: true,
											message: 'Campo requerido.',
										},
									],
								},
							]"
						>
							<a-select-option value="cash"> Efectivo </a-select-option>
							<a-select-option value="bank_transfer"> Dinero en Banco </a-select-option>
						</a-select>
					</a-form-item>
				</div>
				<div class="col-4">
					<a-form-item label="Monto">
						<a-input autocomplete="off" prefix="$" v-money="money" v-model="amount" />
					</a-form-item>
				</div>
				<div class="col-12 pt20 text-right">
					<a-button icon="swap" class="btn btn-success" htmlType="submit">Continuar</a-button>
				</div>
			</div>
		</a-form>
	</a-spin>
</template>

<script>
import { mapGetters } from 'vuex'
import { VMoney } from 'v-money'
import numeral from 'numeral'
import Swal from 'sweetalert2'

export default {
	name: 'swapMoneyComponent',
	computed: {
		...mapGetters('cashFlow', ['spinnerLoaderLabel', 'spinnerLoader']),
	},
	directives: {
		money: VMoney,
	},
	data: function () {
		return {
			form: this.$form.createForm(this),
			money: {
				decimal: '.',
				thousands: ',',
				precision: 2,
			},
			amount: numeral(0).format('0,0.00'),
		}
	},
	methods: {
		cleanData() {
			this.form.resetFields()
			this.amount = numeral(0).format('0,0.00')
		},
		handleSubmit(e) {
			e.preventDefault()
			this.form.validateFields((err, values) => {
				if (!err) {
					//
					if (numeral(this.amount).value() < 1) {
						Swal.fire({
							title: 'Traslado de valores',
							text: 'Debes ingresar monto para continuar',
							icon: 'warning',
							confirmButtonText: 'Ok',
						})
						return false
					}
					let { amount } = this
					this.$store.dispatch('cashFlow/SWAP_MONEY', {
						...values,
						amount,
					})
				}
			})
		},
	},
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>